<script lang="ts">
  interface Props {
    type?: string;
  }

  let { type = "" }: Props = $props();
</script>

<div class="loading {type}">
  <img
    src="/images/logo-bixoto.png"
    alt="Loading..."
    width="498px"
    height="105px"
    class="logo"
  />
</div>


<style lang="scss">
  .loading {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 100px;
		height: 100%;
		overflow-y: hidden;
		transition: all linear 0.25s;

		&.search {
			height: auto;
			padding: 10px;
			width: 100%;
			flex-grow: 1;
			overflow: hidden;
			min-height: 30px;

			img {
				width: 120px;
				height: auto;
			}
		}

		.logo {
			width: 180px;
			height: 37.5px;
			animation: zoomInOut 2s infinite alternate; /* Animation with 2 seconds duration, alternating infinite times */
		}

		@keyframes zoomInOut {
			0% {
				transform: scale(1); /* Initial scale (normal size) */
			}
			50% {
				transform: scale(1.2); /* Zoom in to 120% */
			}
			100% {
				transform: scale(1); /* Back to normal size */
			}
		}
	}
</style>
